import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, rem, spacing, utilityStyles, zIndex } from '../../../styles';
import StyledMultiSelectChip from './multi-select.chip.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("align-items:center;display:flex;flex-wrap:wrap;max-width:calc(100% - ", rem(spacing.spacingControlHeightLg + 12), ");padding:", rem(4, 0, 0, 0), ";pointer-events:none;z-index:", zIndex.zIndex_1, ";", StyledMultiSelectChip, "{margin:", rem(4, 0, 4, 8), ";pointer-events:all;}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledMultiSelectAffix = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1wdf5qs0"
} : {
  target: "e1wdf5qs0",
  label: "StyledMultiSelectAffix"
})(resetStyles, defaultStyles, utilityStyles);
export default StyledMultiSelectAffix;